<template>
    <section class="bg-light shadow-sm index-forward" v-if="list.length > 0" id="notice">
      <div class="container-fluid">
        <div class="card rounded-0 border-0">
          <div class="card-body p-4 p-lg-5">

               <loading :active.sync="isLoading" 
                        :can-cancel="true" 
                        :on-cancel="onCancel"
                        :is-full-page="true"></loading>
           
                <div class="container">

                

                  <div class="row bg-light py-3">

                     <div class="col-lg-12 col-md-12 col-sm-12">
                        <h2><span class="text-primary"> Notices </span></h2> <hr>
                        
                        <div class="alert alert-info" v-for="item in notices" :key="item.id">
                           <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                           <strong>{{ item.name }} : </strong> {{ item.description }} | <b>{{ item.date }}</b>
                        </div>

                     </div>

                   </div>

                </div>
              
          </div>
        </div>
      </div>
    </section>
</template>
<script>
    import DocumentLibraryServices from "../../services/DocumentLibraryServices";
    import $ from 'jquery';
    import Loading from 'vue-loading-overlay';
    export default {
        components:{
            Loading,
        },
        data(){
            return {
                isLoading: false,
                limit: 1,
                types: [],
                filter: '',
                list: [],
                date: '',
                dateInputClass: '',
                documentTypes: [],
                filters: {},
                selectedID:0,
                notices:[],
            }
        },
        created() {
            this.getDocumentTypes().then((response)=>{
                this.documentTypes = response.data.data;
                this.documentTypes.forEach((value) => {
                    if(value.name === "Notices" || value.name === "notices"){
                        this.selectedID = value.id;
                        this.onFilter();
                    }
                });
            });

            setTimeout(function(){
               $('#notice').hide('fade in');
            }, 50000);
        },

        mounted() {
            if(this.$refs.dateInputFrom){
            const now =  Date.now();
            const lastMonth = now - 31*24*60*60*1000;

            this.$refs.dateInputFrom.value=new Date(lastMonth).toISOString().slice(0,10);
            this.$refs.dateInputTo.value=new Date(now).toISOString().slice(0,10);

            this.getTypes().then((resp)=>{
               this.types=resp.data.data
            });

            this.filters.typeID = 1;
            }
            
        },
        methods:{
            async getDocumentTypes(){
                try{
                    const responce = await DocumentLibraryServices.getDocumentsTypes();
                    return responce;
                }catch (e) {
                    return e;
                }
            },
            async getDocuments(obj){
                try{
                    const responce = await DocumentLibraryServices.getDocuments(obj);
                    return responce;
                }
                catch (e) {
                    return e;
                }
            },
            onFilter(){
                this.isLoading = true;
                this.filters.typeID= this.selectedID;
                this.getDocuments(this.filters).then((resp)=>{
                    this.list = resp.data.data;
                    this.isLoading = false;

                    this.list.forEach((value) => {
                       if(new Date(value.date).getFullYear() === new Date().getFullYear()){
                           this.notices.push(value);
                       }
                    });
                });
            },
        }
    }
</script>
<style scoped>
  .img {
      border-radius: 5px;
  }  
</style>